import { i18n } from '@everfi/reactifi/src/i18n/translate';
i18n.loadTranslations();

// Ensure fil-PH works when browser detects it but translations are under tl-PH
if (typeof window !== 'undefined' && window.translations) {
  Object.values(window.translations).forEach(translation => {
    // If we have tl-PH translations, ensure fil-PH also works
    if (translation['tl-PH']) {
      // Ensure the resource bundle is registered for fil-PH
      i18n.addResourceBundle('fil-PH', 'defaultNamespace', translation['tl-PH'], true, true);
    }
  });
}

export default i18n;
